export default __webpack_public_path__ + "static/favicon-50dbe2e9fe658477ff649b73937543c0.ico";